/**
 * Waseem Baby Store - Global Multi-Currency Engine
 * Handles 34+ global currencies with real-time price conversion across:
 * - Product Details Page (Main price, compare-at price, discounts)
 * - Add to Cart button (Button label price)
 * - Sticky Floating Add to Cart bar
 * - Custom Product Bundles & Addons
 * - Dore Collection Tabs & Product Cards
 * - Cart Drawer, Cart Items, Cart Subtotals & Free Shipping Bar
 * - Shopify Checkout Market synchronization
 * - Real-time Variant changes & DOM morphing
 */

(function() {
  'use strict';

  // 34 Global Countries & Currencies Definition
  const AVAILABLE_COUNTRIES = [
    { name: 'Netherlands', code: 'NL', currency: 'EUR', symbol: '€', rate: 1.0, flag: '🇳🇱' },
    { name: 'Belgium', code: 'BE', currency: 'EUR', symbol: '€', rate: 1.0, flag: '🇧🇪' },
    { name: 'Germany', code: 'DE', currency: 'EUR', symbol: '€', rate: 1.0, flag: '🇩🇪' },
    { name: 'France', code: 'FR', currency: 'EUR', symbol: '€', rate: 1.0, flag: '🇫🇷' },
    { name: 'Spain', code: 'ES', currency: 'EUR', symbol: '€', rate: 1.0, flag: '🇪🇸' },
    { name: 'Italy', code: 'IT', currency: 'EUR', symbol: '€', rate: 1.0, flag: '🇮🇹' },
    { name: 'Austria', code: 'AT', currency: 'EUR', symbol: '€', rate: 1.0, flag: '🇦🇹' },
    { name: 'Ireland', code: 'IE', currency: 'EUR', symbol: '€', rate: 1.0, flag: '🇮🇪' },
    { name: 'Portugal', code: 'PT', currency: 'EUR', symbol: '€', rate: 1.0, flag: '🇵🇹' },
    { name: 'United Kingdom', code: 'GB', currency: 'GBP', symbol: '£', rate: 0.855, flag: '🇬🇧' },
    { name: 'United States', code: 'US', currency: 'USD', symbol: '$', rate: 1.085, flag: '🇺🇸' },
    { name: 'Canada', code: 'CA', currency: 'CAD', symbol: 'CA$', rate: 1.485, flag: '🇨🇦' },
    { name: 'Australia', code: 'AU', currency: 'AUD', symbol: 'AU$', rate: 1.655, flag: '🇦🇺' },
    { name: 'United Arab Emirates', code: 'AE', currency: 'AED', symbol: 'AED ', rate: 3.98, flag: '🇦🇪' },
    { name: 'Saudi Arabia', code: 'SA', currency: 'SAR', symbol: 'SAR ', rate: 4.07, flag: '🇸🇦' },
    { name: 'Qatar', code: 'QA', currency: 'QAR', symbol: 'QAR ', rate: 3.95, flag: '🇶🇦' },
    { name: 'Kuwait', code: 'KW', currency: 'KWD', symbol: 'KD ', rate: 0.334, flag: '🇰🇼' },
    { name: 'Bahrain', code: 'BH', currency: 'BHD', symbol: 'BD ', rate: 0.409, flag: '🇧🇭' },
    { name: 'Oman', code: 'OM', currency: 'OMR', symbol: 'OMR ', rate: 0.418, flag: '🇴🇲' },
    { name: 'Pakistan', code: 'PK', currency: 'PKR', symbol: 'Rs ', rate: 302.5, flag: '🇵🇰' },
    { name: 'India', code: 'IN', currency: 'INR', symbol: '₹', rate: 90.8, flag: '🇮🇳' },
    { name: 'Switzerland', code: 'CH', currency: 'CHF', symbol: 'CHF ', rate: 0.965, flag: '🇨🇭' },
    { name: 'Japan', code: 'JP', currency: 'JPY', symbol: '¥', rate: 165.2, flag: '🇯🇵' },
    { name: 'Sweden', code: 'SE', currency: 'SEK', symbol: 'kr ', rate: 11.45, flag: '🇸🇪' },
    { name: 'Norway', code: 'NO', currency: 'NOK', symbol: 'kr ', rate: 11.62, flag: '🇳🇴' },
    { name: 'Denmark', code: 'DK', currency: 'DKK', symbol: 'kr ', rate: 7.46, flag: '🇩🇰' },
    { name: 'Poland', code: 'PL', currency: 'PLN', symbol: 'zł ', rate: 4.31, flag: '🇵🇱' },
    { name: 'Turkey', code: 'TR', currency: 'TRY', symbol: '₺', rate: 36.8, flag: '🇹🇷' },
    { name: 'Brazil', code: 'BR', currency: 'BRL', symbol: 'R$ ', rate: 5.88, flag: '🇧🇷' },
    { name: 'Singapore', code: 'SG', currency: 'SGD', symbol: 'SG$', rate: 1.46, flag: '🇸🇬' },
    { name: 'New Zealand', code: 'NZ', currency: 'NZD', symbol: 'NZ$', rate: 1.78, flag: '🇳🇿' },
    { name: 'South Africa', code: 'ZA', currency: 'ZAR', symbol: 'R ', rate: 19.85, flag: '🇿🇦' },
    { name: 'Mexico', code: 'MX', currency: 'MXN', symbol: 'MX$', rate: 21.6, flag: '🇲🇽' },
    { name: 'China', code: 'CN', currency: 'CNY', symbol: '¥', rate: 7.85, flag: '🇨🇳' }
  ];

  window.WASEEM_COUNTRIES = AVAILABLE_COUNTRIES;

  function getActiveCountry() {
    const saved = localStorage.getItem('waseem_selected_country');
    if (saved) {
      const found = AVAILABLE_COUNTRIES.find(c => c.code === saved);
      if (found) return found;
    }
    return AVAILABLE_COUNTRIES[0]; // Default Netherlands (EUR)
  }

  window.setWebsiteCountry = function(countryCode) {
    if (!countryCode) return;
    const cleanCode = countryCode.trim().toUpperCase();
    let country = AVAILABLE_COUNTRIES.find(c => c.code.toUpperCase() === cleanCode);
    
    // If not in predefined list, extract metadata from DOM
    if (!country) {
      const domOption = document.querySelector(`[data-code="${cleanCode}"]`);
      if (domOption) {
        const item = domOption.closest('li');
        const name = item ? (item.getAttribute('data-country-name') || cleanCode) : cleanCode;
        const cur = item ? (item.getAttribute('data-currency-code') || 'EUR').toUpperCase() : 'EUR';
        country = {
          name: name.charAt(0).toUpperCase() + name.slice(1),
          code: cleanCode,
          currency: cur,
          symbol: '',
          rate: 1.0,
          flag: getCountryFlag(cleanCode)
        };
      }
    }

    if (!country) return;

    localStorage.setItem('waseem_selected_country', country.code);
    localStorage.setItem('waseem_selected_currency', country.currency);

    updateCountryUI(country);
    convertAllPrices(country);

    try {
      window.dispatchEvent(new CustomEvent('waseem:currency:changed', { detail: { country } }));
    } catch(err) {}

    // Submit Shopify localization form so Shopify Markets switches the session country location & currency for Checkout
    const form = document.getElementById('DoreTopbarCountryForm') ||
                 document.getElementById('DoreDrawerCountryForm') ||
                 document.getElementById('DoreGlobalLocalizationForm') ||
                 document.querySelector('form[action*="/localization"]');
    if (form) {
      let codeInput = form.querySelector('input[name="country_code"]');
      if (!codeInput) {
        codeInput = document.createElement('input');
        codeInput.type = 'hidden';
        codeInput.name = 'country_code';
        form.appendChild(codeInput);
      }
      codeInput.value = country.code;

      let returnInput = form.querySelector('input[name="return_to"]');
      if (!returnInput) {
        returnInput = document.createElement('input');
        returnInput.type = 'hidden';
        returnInput.name = 'return_to';
        form.appendChild(returnInput);
      }
      returnInput.value = window.location.pathname + window.location.search;

      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit();
      } else {
        HTMLFormElement.prototype.submit.call(form);
      }
    }
  };

  function getCountryFlag(isoCode) {
    if (!isoCode || isoCode.length !== 2) return '🌐';
    const code = isoCode.toUpperCase();
    try {
      return String.fromCodePoint(...[...code].map(c => c.charCodeAt(0) + 127397));
    } catch (e) {
      return '🌐';
    }
  }

  function renderCountryFlags() {
    document.querySelectorAll('[data-country-flag]').forEach(el => {
      const code = el.getAttribute('data-country-flag');
      if (code) {
        el.textContent = getCountryFlag(code);
      }
    });
  }

  function updateCountryUI(country) {
    if (!country) return;
    const cleanCode = (country.code || '').toUpperCase();
    const cleanSymbol = country.symbol ? country.symbol.trim() : '';
    const flagEmoji = country.flag || getCountryFlag(cleanCode);

    renderCountryFlags();

    // 1. Update Drawer Trigger Button (Flag + Label)
    const drawerCountryLabels = document.querySelectorAll('#dore-country-current-label, .dore-drawer__top-item--country .dore-drawer__top-text');
    drawerCountryLabels.forEach(el => {
      el.textContent = `${country.name.toUpperCase()} (${country.currency}${cleanSymbol ? ' ' + cleanSymbol : ''})`;
    });

    const drawerFlags = document.querySelectorAll('#dore-drawer-current-flag, .dore-drawer__top-item--country .dore-drawer__flag');
    drawerFlags.forEach(el => {
      el.textContent = flagEmoji;
    });

    // 2. Update Topbar Trigger Button (Flag + Name + Currency)
    const topbarNames = document.querySelectorAll('.dore-topbar__country-name');
    topbarNames.forEach(el => {
      el.textContent = country.name;
    });

    const topbarCurs = document.querySelectorAll('.dore-topbar__country-cur');
    topbarCurs.forEach(el => {
      el.textContent = `(${country.currency}${cleanSymbol ? ' ' + cleanSymbol : ''})`;
    });

    const topbarFlags = document.querySelectorAll('#dore-topbar-current-flag, .dore-topbar__flag');
    topbarFlags.forEach(el => {
      el.textContent = flagEmoji;
    });

    // 3. Update Drawer List Active States & Checkmarks
    document.querySelectorAll('.dore-country-select-btn').forEach(btn => {
      const code = (btn.getAttribute('data-code') || '').toUpperCase();
      const item = btn.closest('li') || btn.parentElement;
      if (code === cleanCode) {
        if (item) item.classList.add('is-active');
        if (!btn.querySelector('.dore-drawer__check')) {
          const check = document.createElement('span');
          check.className = 'dore-drawer__check';
          check.textContent = '✓';
          btn.appendChild(check);
        }
      } else {
        if (item) item.classList.remove('is-active');
        const check = btn.querySelector('.dore-drawer__check');
        if (check) check.remove();
      }
    });

    // 4. Update Topbar List Active States & Checkmarks
    document.querySelectorAll('.dore-topbar__country-option').forEach(btn => {
      const code = (btn.getAttribute('data-code') || '').toUpperCase();
      const item = btn.closest('li') || btn.parentElement;
      if (code === cleanCode) {
        if (item) item.classList.add('is-active');
        if (!btn.querySelector('.dore-topbar__check')) {
          const check = document.createElement('span');
          check.className = 'dore-topbar__check';
          check.setAttribute('aria-hidden', 'true');
          check.textContent = '✓';
          btn.appendChild(check);
        }
      } else {
        if (item) item.classList.remove('is-active');
        const check = btn.querySelector('.dore-topbar__check');
        if (check) check.remove();
      }
    });
  }

  function bindCountryOptions() {
    // 1. Drawer Option Clicks
    document.querySelectorAll('.dore-country-select-btn').forEach(btn => {
      btn.onclick = function(e) {
        e.preventDefault();
        e.stopPropagation();
        const code = this.getAttribute('data-code');
        if (code) {
          window.setWebsiteCountry(code);
        }
        const panel = document.getElementById('dore-country-panel');
        const toggle = document.getElementById('dore-country-trigger');
        if (panel) {
          panel.classList.remove('is-open');
          panel.setAttribute('hidden', '');
        }
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
      };
    });

    // 2. Topbar Option Clicks
    document.querySelectorAll('.dore-topbar__country-option').forEach(btn => {
      btn.onclick = function(e) {
        e.preventDefault();
        e.stopPropagation();
        const code = this.getAttribute('data-code');
        if (code) {
          window.setWebsiteCountry(code);
        }
        const dropdown = document.getElementById('dore-topbar-country-dropdown');
        const toggle = document.getElementById('dore-topbar-country-toggle');
        if (dropdown) dropdown.setAttribute('hidden', '');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
        const section = document.querySelector('.dore-topbar');
        if (section) section.classList.remove('is-dropdown-open');
      };
    });

    // 3. Search Input in Drawer
    const drawerSearch = document.getElementById('dore-country-search-input');
    if (drawerSearch) {
      drawerSearch.oninput = function(e) {
        const query = (e.target.value || '').trim().toLowerCase();
        document.querySelectorAll('#dore-country-results .dore-country-option').forEach(opt => {
          const name = opt.getAttribute('data-country-name') || '';
          const code = opt.getAttribute('data-country-code') || '';
          const cur = opt.getAttribute('data-currency-code') || '';
          const text = opt.textContent.toLowerCase();
          if (!query || name.includes(query) || code.includes(query) || cur.includes(query) || text.includes(query)) {
            opt.style.display = '';
          } else {
            opt.style.display = 'none';
          }
        });
      };
    }

    // 4. Search Input in Topbar
    const topbarSearch = document.getElementById('dore-topbar-search-input');
    if (topbarSearch) {
      topbarSearch.oninput = function(e) {
        const query = (e.target.value || '').trim().toLowerCase();
        document.querySelectorAll('#dore-topbar-country-list .dore-topbar__country-item').forEach(opt => {
          const name = opt.getAttribute('data-country-name') || '';
          const code = opt.getAttribute('data-country-code') || '';
          const cur = opt.getAttribute('data-currency-code') || '';
          const text = opt.textContent.toLowerCase();
          if (!query || name.includes(query) || code.includes(query) || cur.includes(query) || text.includes(query)) {
            opt.style.display = '';
          } else {
            opt.style.display = 'none';
          }
        });
      };
    }
  }

  // =========================================================================
  // PRICE CONVERSION HELPERS
  // =========================================================================
  function parsePrice(text) {
    if (!text) return null;
    const cleanText = text.replace(/EUR|USD|GBP|SAR|AED|QAR|PKR|INR|CAD|AUD|CHF|KWD|BHD|OMR|JPY|SEK|NOK|DKK|PLN|TRY|BRL|SGD|NZD|ZAR|MXN|CNY|KD|BD|Rs|kr|zł|₺|R\$|SG\$|NZ\$|MX\$|CA\$|AU\$|€|\$|£|¥|₹|R\b/gi, '').trim();
    const match = cleanText.match(/[\d.,]+/);
    if (!match) return null;
    let str = match[0];
    if (str.indexOf('.') !== -1 && str.indexOf(',') !== -1) {
      if (str.indexOf('.') < str.indexOf(',')) {
        str = str.replace(/\./g, '').replace(',', '.');
      } else {
        str = str.replace(/,/g, '');
      }
    } else if (str.indexOf(',') !== -1) {
      str = str.replace(',', '.');
    }
    const val = parseFloat(str);
    return isNaN(val) ? null : val;
  }

  function formatMoney(amount, currency, symbol) {
    const cleanSymbol = (symbol || '').trim();
    if (currency === 'EUR') {
      return `€${amount.toFixed(2).replace('.', ',')}`;
    }
    if (['USD', 'CAD', 'AUD', 'NZD', 'SGD', 'HKD'].includes(currency)) {
      return `${cleanSymbol}${amount.toFixed(2)}`;
    }
    if (currency === 'GBP') {
      return `£${amount.toFixed(2)}`;
    }
    if (['PKR', 'INR', 'JPY', 'KRW'].includes(currency)) {
      return `${cleanSymbol} ${Math.round(amount).toLocaleString('en-US')}`;
    }
    if (['TRY', 'NOK', 'SEK', 'DKK', 'PLN', 'ZAR', 'MXN', 'BRL', 'CNY', 'CHF'].includes(currency)) {
      return `${cleanSymbol} ${amount.toFixed(2).replace('.', ',')}`;
    }
    if (['SAR', 'AED', 'QAR', 'KWD', 'BHD', 'OMR'].includes(currency)) {
      return `${cleanSymbol} ${amount.toFixed(2)}`;
    }
    return `${cleanSymbol} ${amount.toFixed(2)}`;
  }

  function convertAllPrices(country) {
    if (!country) return;

    const isEur = (country.currency === 'EUR' && country.rate === 1.0);

    const priceSelectors = [
      // Main product price display block
      '[class*="ai-price-display__compare"]',
      '[class*="ai-price-display__current"]',
      '[class*="ai-price-display__no-compare"]',
      '[class*="ai-price-display__price"]',
      // Add to cart button & sticky bar
      '.add-to-cart__price-val',
      '.add-to-cart__price',
      '.sticky-atc__price-val',
      // Product card & theme prices
      '.product-price',
      '.price-item',
      '.price-item--regular',
      '.price-item--sale',
      '.price-item--last',
      '.compare-at-price',
      '.price',
      '.product__price',
      '.dore-product-price',
      '.dore-product-price--sale',
      '.dore-product-price--compare',
      '.dore-sticky-cart__price',
      '.quick-add__price',
      '.money',
      // Dore collection tabs & video reels
      '.dore-tabs__price-current',
      '.dore-tabs__price-compare',
      '[class*="dore-tabs__price-"]',
      '.dore-vr__cat-price',
      // AI Gen Related products / Bekijk ook
      '[class*="ai-related-products__compare-price"]',
      '[class*="ai-related-products__regular-price"]',
      '[class*="ai-related-products__price-"]',
      // Featured collections
      '.ai-featured-collection__price',
      '.ai-featured-collection__price-compare',
      '[class*="ai-featured-collection__price-"]',
      '[class*="ai-featured-collection__price_"]',
      // Cart drawer, Cart table & Cart totals
      '.cart-totals__total-value',
      '.cart-totals__original-value',
      '.cart-discounts__value',
      '.cart-items__unit-price-wrapper span',
      '.cart-items__unit-price-text span',
      '.cart-items__price text-component',
      'text-component[data-cart-subtotal]',
      'text-component[ref="cartTotal"]',
      '.cart-drawer__total-price',
      '.cart-drawer__subtotal-value',
      '.cart-drawer__item-price',
      '.cart-drawer__item-original-price',
      '.cart-item__price',
      '.cart-item__original-price',
      '.cart-item__discounted-price',
      '.cart-shipping-bar__remaining',
      // Cart upsells
      '.cart-upsell-card__price-compare',
      '.cart-upsell-card__price-current'
    ];

    document.querySelectorAll(priceSelectors.join(',')).forEach(el => {
      // Exclude custom product bundle (it manages its own live multi-currency recalculation)
      if (el.closest('custom-product-bundle, .custom-product-bundle, .custom-bundle-card')) {
        return;
      }

      // Exclude container elements or elements with complex children that are not simple price spans
      if (
        el.matches('[class*="wrapper"], [class*="row"], [class*="container"]') ||
        (el.children.length > 0 && !el.matches('.price-item, .money, .product-price, text-component, .cart-totals__total-value, .cart-totals__original-value'))
      ) {
        return;
      }

      let baseEur = null;

      // 1. Check data-base-price (cents or decimal)
      const basePriceAttr = el.getAttribute('data-base-price');
      if (basePriceAttr) {
        const raw = parseFloat(basePriceAttr);
        if (!isNaN(raw) && raw > 0) {
          baseEur = raw > 1000 && !basePriceAttr.includes('.') ? raw / 100.0 : raw;
        }
      }

      // 2. Fallback to data-original-price or textContent
      let original = el.getAttribute('data-original-price');
      if (!original) {
        original = el.textContent.trim();
        if (!original || !/[\d]/.test(original)) return;
        el.setAttribute('data-original-price', original);
      }

      if (baseEur === null) {
        baseEur = parsePrice(original);
      }

      if (baseEur === null || baseEur <= 0) return;

      if (isEur) {
        el.textContent = formatMoney(baseEur, 'EUR', '€');
        return;
      }

      const converted = baseEur * country.rate;
      el.textContent = formatMoney(converted, country.currency, country.symbol);
    });

    // Special check for Add to Cart button text if not yet split
    document.querySelectorAll('.add-to-cart-text__content span, .sticky-atc__btn-text').forEach(span => {
      if (span.querySelector('.add-to-cart__price-val, .sticky-atc__price-val')) return;
      const text = span.textContent || '';
      if (text.includes('€') || text.includes('Add to cart') || text.includes('Voeg toe')) {
        const match = text.match(/([€$£¥₹]|KD|BD|Rs|kr|zł|₺|AED|SAR|QAR)\s*[\d.,]+/i);
        if (match) {
          let origFull = span.getAttribute('data-original-full-text');
          if (!origFull) {
            origFull = text;
            span.setAttribute('data-original-full-text', origFull);
          }
          const baseEur = parsePrice(match[0]);
          if (baseEur && baseEur > 0) {
            const formatted = isEur ? formatMoney(baseEur, 'EUR', '€') : formatMoney(baseEur * country.rate, country.currency, country.symbol);
            span.textContent = origFull.replace(match[0], formatted);
          }
        }
      }
    });

    // Trigger custom product bundle recalculation for all item rows & totals
    document.querySelectorAll('custom-product-bundle').forEach(bundle => {
      if (typeof bundle.recalculate === 'function') {
        bundle.recalculate();
      }
    });
  }

  // =========================================================================
  // INITIALIZATION & EVENT LISTENERS
  // =========================================================================
  function init() {
    const activeCountry = getActiveCountry();

    bindCountryOptions();
    updateCountryUI(activeCountry);

    if (activeCountry.currency !== 'EUR') {
      setTimeout(() => convertAllPrices(activeCountry), 50);
      setTimeout(() => convertAllPrices(activeCountry), 200);
      setTimeout(() => convertAllPrices(activeCountry), 600);
      setTimeout(() => convertAllPrices(activeCountry), 1500);
      setTimeout(() => convertAllPrices(activeCountry), 3000);
    }

    if (window.MutationObserver) {
      let debounceTimer = null;
      const observer = new MutationObserver(function() {
        if (debounceTimer) clearTimeout(debounceTimer);
        debounceTimer = setTimeout(function() {
          const c = getActiveCountry();
          if (c.currency !== 'EUR') {
            convertAllPrices(c);
          }
        }, 80);
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function() {
    bindCountryOptions();
    const active = getActiveCountry();
    updateCountryUI(active);
    if (active.currency !== 'EUR') {
      convertAllPrices(active);
    }
  });

  // Listen to variant changes across the theme
  window.addEventListener('variant:update', function() {
    const active = getActiveCountry();
    if (active.currency !== 'EUR') {
      setTimeout(() => convertAllPrices(active), 50);
      setTimeout(() => convertAllPrices(active), 200);
    }
  });

  window.addEventListener('variant:selected', function() {
    const active = getActiveCountry();
    if (active.currency !== 'EUR') {
      setTimeout(() => convertAllPrices(active), 50);
    }
  });

  // Listen to cart events (cart drawer open, line item added, quantity updated)
  ['cart:update', 'cart:add', 'cart:change', 'cart:refresh', 'cart-items:update'].forEach(function(evt) {
    document.addEventListener(evt, function() {
      const active = getActiveCountry();
      if (active.currency !== 'EUR') {
        setTimeout(() => convertAllPrices(active), 60);
        setTimeout(() => convertAllPrices(active), 250);
        setTimeout(() => convertAllPrices(active), 600);
      }
    });
  });

  window.convertAllPrices = convertAllPrices;

})();
